import { TournamentRewardType } from "../../models/User"
import { BoostIcon } from "../svg/BoostIcon"
import USDTIcon from "../svg/USDTIcon"
import { CollectibleIcon } from "../ui/collectible-icon"
import { GemsIcon } from "../ui/gems-icon"

interface LeagueRewardIconProps {
  type:TournamentRewardType,
  size?:string
}

// TODO - Need refactoring (step collectible)

function iconByType(type:TournamentRewardType, size:string) {

  if(size == "notification") {

    switch(type) {
      case TournamentRewardType.SILVER_COLLECTIBLE:
        return <CollectibleIcon step="silver" widthCss="w-10"/>;
      case TournamentRewardType.BRONZE_COLLECTIBLE:
        return <CollectibleIcon step="bronze" widthCss="w-10"/>;
      case TournamentRewardType.GEMS:
        return <GemsIcon h={50}/>
      case TournamentRewardType.POWER_UP:
        return <BoostIcon h={50}/>
      case TournamentRewardType.CRYPTO:
        return <USDTIcon h={50}/>
      default:
        return type;
    }

  } else {

    switch(type) {
      case TournamentRewardType.SILVER_COLLECTIBLE:
        return <CollectibleIcon step="silver"/>;
      case TournamentRewardType.BRONZE_COLLECTIBLE:
        return <CollectibleIcon step="bronze" />;
      case TournamentRewardType.GEMS:
        return <GemsIcon/>
      case TournamentRewardType.POWER_UP:
        return <BoostIcon/>
      case TournamentRewardType.CRYPTO:
        return <USDTIcon h={24}/>
      default:
        return type;
    }

  }

}

const LeagueRewardIcon: React.FC<LeagueRewardIconProps> = ({type, size=""}) => {
  return (
    <>{iconByType(type, size)}</>
   );
}

export default LeagueRewardIcon;